window.axios = require("axios");
import Alpine from "alpinejs";
import Fuse from "fuse.js";

window.Fuse = Fuse;
window.Alpine = Alpine;

import hljs from "highlight.js/lib/core";
window.$ = window.jQuery = require("jquery");

Alpine.start();

// Syntax highlighting
hljs.registerLanguage("bash", require("highlight.js/lib/languages/bash"));
hljs.registerLanguage("css", require("highlight.js/lib/languages/css"));
hljs.registerLanguage("html", require("highlight.js/lib/languages/xml"));
hljs.registerLanguage(
  "javascript",
  require("highlight.js/lib/languages/javascript")
);
hljs.registerLanguage("json", require("highlight.js/lib/languages/json"));
hljs.registerLanguage(
  "markdown",
  require("highlight.js/lib/languages/markdown")
);
hljs.registerLanguage("php", require("highlight.js/lib/languages/php"));
hljs.registerLanguage("scss", require("highlight.js/lib/languages/scss"));
hljs.registerLanguage("yaml", require("highlight.js/lib/languages/yaml"));

document.querySelectorAll("pre code").forEach((block) => {
  hljs.highlightBlock(block);
});

/* Navigation */
var navContainer = document.querySelector("#header-nav");
var btnNav = document.querySelector("#mobile-nav-container");
var isNavOpened = false;

btnNav.addEventListener("click", (e) => {
  e.preventDefault();
  isNavOpened = !isNavOpened;
  navContainer.classList.toggle("nav-opened");
});

/* Contact Form */
if ($("form.ajax-form").length > 0) {
  $("form.ajax-form").each(function (index, form) {
    axios({
      method: "GET",
      url: $(form).attr("action"),
    });
  });

  $(document).on("submit", "form.ajax-form", function (e) {
    e.preventDefault();
    var currentForm = $(this); // Get current form object

    // disable submit button
    $("[type=submit]", currentForm).attr("disabled", "disabled");
    // clean up the msg container
    $(".msg-container", currentForm)
      .html("")
      .attr("class", "msg-container")
      .css("display", "none");
    // remove fields error classes
    currentForm.find(".is-invalid").removeClass("is-invalid");
    // add preloader
    $("[type=submit]", currentForm).html(
      $("[type=submit]", currentForm).data("btn-label-processing")
    );

    let formData = $(this)
      .serializeArray()
      .map(
        function (x) {
          this[x.name] = x.value;
          return this;
        }.bind({})
      )[0];

    axios({
      method: $(this).attr("method"),
      url: $(this).attr("action"),
      data: formData,
    })
      .then(function (response) {
        var hand = setTimeout(function () {
          // clear the form if form submitted successfully
          $(currentForm).trigger("reset");

          // show returned message
          $(".msg-container", currentForm)
            .addClass("msg-success")
            .html(response.data["message"])
            .css("display", "block");

          // enable submit button again
          var btnLabel = $("[type=submit]", currentForm).data("btn-label");
          // $("[type=submit]", currentForm).removeAttr("disabled");
          $("[type=submit]", currentForm).html(btnLabel);
          clearTimeout(hand);
        }, 1000);
      })
      .catch(function (error) {
        // show returned message
        $(".msg-container", currentForm)
          .addClass("msg-error")
          .html(error.response.data["message"])
          .css("display", "block");

        // enable submit button again
        var btnLabel = $("[type=submit]", currentForm).data("btn-label");
        $("[type=submit]", currentForm).removeAttr("disabled");
        $("[type=submit]", currentForm).html(btnLabel);
      });

    return false;
  });
}
